<!-- <div class="stripe-wrapper">
    <div class="stripe-inner"> -->
<stripe-pricing-table [attr.pricing-table-id]="pricingTableId" [attr.publishable-key]="publishableKey">
</stripe-pricing-table>
<!-- </div>
</div> -->

<!-- <iframe
    src="https://buy.stripe.com/pricing-table/prctbl_1RHdmnQT8L3BAA7mRancf7r0
?publishableKey=pk_test_51RGAu7QT8L3BAA7mZrt5WNM34po7M4dZOvPfGVjTfUdw2z2Df7TMWndWhOzqZRuRpR8B5z3FBfMzYpI2mCL7o4LE00VnyU1hhS"
    width="100%" height="600" frameborder="0" style="border: none;">
</iframe>

<iframe [src]="iframeSrc" width="100%" height="600" frameborder="0" style="border: none;">
</iframe> -->